export default __webpack_public_path__ + "static/AjayRavindra-8cfb4bb1445a70aefef8e0bb7696ca8e.png";